module.exports = __webpack_public_path__ + "img/merry.a110e137.jpg";